import React from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

import { IconButton } from "@braintrust/braintrust-ui-components";
import {
  ArrowLeftIcon,
  CloseIcon,
} from "@braintrust/braintrust-ui-components/Icons";
import { RouterLink } from "@js/components/link";
import { Logo } from "@js/components/logo";

import { getQuery } from "../../utils";
import type { CoreLayoutProps } from "../core";
import { CoreLayout } from "../core";

import styles from "./styles.module.scss";

type FullPageLayoutProps = CoreLayoutProps & {
  closeURL?: string;
  closeIcon?: string;
  className?: string;
  narrow?: boolean;
  centered?: boolean;
  showLogo?: boolean;
  back?: boolean;
  headerLeft?: React.ReactNode;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
};

const FullPageLayout = ({
  children,
  className,
  closeURL,
  closeIcon,
  narrow,
  centered,
  showLogo,
  back,
  headerLeft,
  headerRight,
  ...rest
}: FullPageLayoutProps) => {
  const { state: locationState } = useLocation();
  const prevPath = locationState?.prevPath;
  const backURL = back && (getQuery("back") || prevPath);
  const buttonURL = backURL || closeURL || "";
  const buttonUrlNotAuth = buttonURL.startsWith("/auth/")
    ? "/talent/invoices/"
    : buttonURL;

  return (
    <CoreLayout
      {...rest}
      className={classNames(styles.fullPageLayout, className, {
        [styles.narrow]: narrow,
        [styles.centered]: centered,
      })}
    >
      <div className={`${styles.fullPageLayoutHeader} flex-left-right`}>
        <div>{headerLeft}</div>
        <div className="left">
          {!!buttonUrlNotAuth && (
            <RouterLink to={buttonUrlNotAuth}>
              <IconButton
                aria-label={closeIcon || backURL ? "Go back" : "Close"}
                variant="transparent"
              >
                {closeIcon || backURL ? <ArrowLeftIcon /> : <CloseIcon />}
              </IconButton>
            </RouterLink>
          )}
        </div>
        <div>{headerRight}</div>
      </div>
      <div className={styles.fullPageLayoutContent}>
        {showLogo && <Logo variant="symbol" noLink />}
        {children}
      </div>
    </CoreLayout>
  );
};

export default FullPageLayout;
